import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EllipsisService {

  constructor() { }

  public truncateLongText(d, type, row, meta, ellipsisLimit) {
    // Order, search and type get the original data
    if (type !== 'display') {
      return d;
    }

    if (typeof d !== 'number' && typeof d !== 'string') {
      return d;
    }

    d = d.toString(); // cast numbers

    if (!ellipsisLimit)
      ellipsisLimit = 35;

    if (d.length < ellipsisLimit) {
      return d;
    }

    let shortened = d.substr(0, ellipsisLimit);
    let esc = function (t) {
      return t
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    return '<span class="ellipsis" data-toggle="tooltip" data-placement="top" data-delay="2000" title="' + esc(d) + '">' + shortened + '&#8230;</span>';
  };
}
